import { runtimeValue } from "./runtime-config";

// Resolved at container start from the server's environment (see
// src/runtime-config.ts); falls back to the build-time .env values.
export const API_URL = runtimeValue("API_URL", process.env.REACT_APP_API_URL);
export const DD_CLIENT_TOKEN = runtimeValue(
  "DD_CLIENT_TOKEN",
  process.env.REACT_APP_DD_CLIENT_TOKEN
);
